import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
    Input,
    Textarea,
    Button,
    Autocomplete,
    AutocompleteItem,
} from "@heroui/react";
import { LuSave } from "react-icons/lu";
import { useFetchData } from "@/hooks";

const MaterialSubCategoryForm = ({
    initialData,
    onSubmit,
    isLoading,
    onCancel,
}) => {
    const {
        register,
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            material_category_id: "",
            name: "",
            description: "",
            ...initialData,
        },
    });

    const { data: categories, isLoading: isLoadingCategories } = useFetchData(
        "select/material-category",
    );

    useEffect(() => {
        if (initialData) {
            const resetData = {
                ...initialData,
                material_category_id: initialData.material_category_id
                    ? String(initialData.material_category_id)
                    : "",
            };
            reset(resetData);
        }
    }, [initialData, reset]);

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-4"
            noValidate
        >
            <Controller
                name="material_category_id"
                control={control}
                rules={{ required: "Kategori wajib dipilih" }}
                render={({ field }) => (
                    <Autocomplete
                        label="Kategori"
                        placeholder="Pilih Kategori"
                        variant="bordered"
                        isLoading={isLoadingCategories}
                        defaultItems={categories || []}
                        selectedKey={field.value ? String(field.value) : null}
                        onSelectionChange={(key) => field.onChange(key)}
                        errorMessage={errors.material_category_id?.message}
                        isInvalid={!!errors.material_category_id}
                        isRequired
                    >
                        {(item) => (
                            <AutocompleteItem
                                key={String(item.value)}
                                textValue={item.title}
                            >
                                {item.title}
                            </AutocompleteItem>
                        )}
                    </Autocomplete>
                )}
            />

            <Input
                {...register("name", {
                    required: "Nama sub kategori wajib diisi",
                })}
                label="Nama Sub Kategori"
                placeholder="Contoh: Layer, Starter"
                variant="bordered"
                errorMessage={errors.name?.message}
                isInvalid={!!errors.name}
                isRequired
            />

            <Textarea
                {...register("description")}
                label="Deskripsi"
                placeholder="Deskripsi singkat tentang sub kategori (opsional)"
                variant="bordered"
            />

            <div className="mt-4 flex justify-end gap-2">
                {onCancel && (
                    <Button
                        onPress={onCancel}
                        variant="light"
                        color="danger"
                        size="sm"
                        isDisabled={isLoading}
                    >
                        Batal
                    </Button>
                )}
                <Button
                    color="primary"
                    type="submit"
                    isLoading={isLoading}
                    size="sm"
                    startContent={!isLoading && <LuSave />}
                >
                    Simpan
                </Button>
            </div>
        </form>
    );
};

export default MaterialSubCategoryForm;
